import * as THREE from "three"
import { STLLoader } from "three/examples/jsm/loaders/STLLoader.js"
import { PLYLoader } from "three/examples/jsm/loaders/PLYLoader.js"
import store from "@/store"

const stlLoader = new STLLoader()
const plyLoader = new PLYLoader()

export async function fetchAndLoadModel(
  filename,
  url,
  buffer = null,
  type,
  signal
) {
  try {
    if (buffer) {
      const mesh = loadMesh(buffer, type)
      return mesh
    } else {
      // TODO: Save a decimated mesh for preview purposes?
      const response = await fetch(url, { signal })

      const buffer = await response.arrayBuffer()
      store.commit("SET_MODEL_BUFFER_CACHE", { filename, buffer })

      const mesh = loadMesh(buffer, type)
      return mesh
    }
  } catch (err) {
    if (err.name === "AbortError") {
      // Intentionally aborted
      return
    }
    console.error("Error loading model:", err)
    throw err
  }
}

function loadMesh(buffer, type) {
  let geometry
  if (type === "stl") {
    geometry = stlLoader.parse(buffer)
  } else if (type === "ply") {
    geometry = plyLoader.parse(buffer)
  } else {
    throw new Error(`Unsupported model type: ${type}`)
  }

  const material = new THREE.MeshStandardMaterial({
    color: 0xcccccc,
    roughness: 0.4,
    metalness: 0.1,
    side: THREE.DoubleSide
  })

  geometry.computeVertexNormals()
  geometry.computeBoundingSphere()
  geometry.computeBoundingBox()
  geometry.center()

  const mesh = new THREE.Mesh(geometry, material)
  mesh.castShadow = true
  mesh.receiveShadow = true

  return mesh
}
